import { render, staticRenderFns } from "./DashboardSearch.vue?vue&type=template&id=52438ebc&scoped=true&"
import script from "./DashboardSearch.vue?vue&type=script&lang=js&"
export * from "./DashboardSearch.vue?vue&type=script&lang=js&"
import style0 from "./DashboardSearch.vue?vue&type=style&index=0&id=52438ebc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52438ebc",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VFlex } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VLayout } from 'vuetify/lib/components/VGrid';
import { VSelect } from 'vuetify/lib/components/VSelect';
import { VSwitch } from 'vuetify/lib/components/VSwitch';
import { VTab } from 'vuetify/lib/components/VTabs';
import { VTabItem } from 'vuetify/lib/components/VTabs';
import { VTabs } from 'vuetify/lib/components/VTabs';
installComponents(component, {VBtn,VFlex,VIcon,VLayout,VSelect,VSwitch,VTab,VTabItem,VTabs})
